import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap } from 'rxjs';

import { AccessActions } from './access.actions';
import { AccessApiService } from '../services/access-api.service';

@Injectable()
export class AccessEffects {
  /**
   * Загрузка матрицы прав текущего пользователя при входе в проект.
   * switchMap — при быстрой смене проекта берём только последний запрос.
   * 403 / отсутствие membership → пустая матрица (всё false), это не ошибка UX.
   */
  loadPermissions$ = createEffect(() =>
    this._actions$.pipe(
      ofType(AccessActions.loadPermissions),
      switchMap(({ projectId }) =>
        this._api.getMyPermissions(projectId).pipe(
          map((res) =>
            AccessActions.loadPermissionsSuccess({
              projectId,
              matrix: res.permissions ?? {},
              role: null,
            }),
          ),
          catchError(() => of(AccessActions.loadPermissionsFailure({ projectId }))),
        ),
      ),
    ),
  );

  constructor(
    private readonly _actions$: Actions,
    private readonly _api: AccessApiService,
  ) {}
}
